import { atom } from 'recoil';

import { Note } from '@/components/PdfReader/GeneratePdf/NotePdfDocument';

export const notesAtom = atom<Record<string, Note[]>>({
  key: 'notesAtom',
  default: {},
});
